import React, { useState } from 'react'
import IconV2, { ICON_TYPES } from '../Icon.v2/index'
import { formatPrice } from '../../services/plans/index'
import { H2 } from '../Heading/index'

/**
 * The Share Page FAQ Accordion Question component
 * Displays a single FAQ question and its answer in an accordion style.
 *
 * @param {Object} props - Component props
 * @param {string} props.title - The FAQ question title
 * @param {string} props.answer - The FAQ answer content
 * @returns {JSX.Element} Single FAQ question and answer component
 */
function SharePageFaqAccordionQuestion (props) {
  const { title, answer } = props
  const [isOpen, setIsOpen] = useState(false)

  const toggleOpen = () => setIsOpen((prev) => !prev)

  return (
    <div className="share-page__faq-accordion-question">
      <div
        className="share-page__faq-accordion-question-header"
        onClick={toggleOpen}
      >
        <div className="share-page__faq-accordion-question-title">
          {title}
        </div>

        <IconV2
          className="share-page__faq-accordion-question-chevron"
          type={isOpen ? ICON_TYPES.CHEVRON_UP : ICON_TYPES.CHEVRON_DOWN}
        />
      </div>

      {isOpen && (
        <div className="share-page__faq-accordion-question-answer">
          {answer}
        </div>
      )}
    </div>
  )
}

/**
 * The Share Page FAQ Accordion component
 * Renders a FAQ section with accordion behavior for questions and answers.
 *
 * @param {Object} props - Component props
 * @param {Object} props.staticText - Strings used in the component for display text
 * @param {Object} props.offerPlan - Offer plan data relevant to the FAQ content
 * @param {string} props.language - Current language code for localization
 * @returns {JSX.Element} FAQ Accordion component
 */
function SharePageFaqAccordion (props) {
  const { staticText, offerPlan, language } = props
  const currencyIso = offerPlan.get('currencyIso')
  const monthlyPriceVal = offerPlan.getIn(['costs', '1'], '0')
  const monthlyPrice = formatPrice(currencyIso, monthlyPriceVal, false, null, language)

  return (
    <div className="share-page__faq-accordion">
      <H2 className="share-page__title share-page__faq-accordion-title">
        {staticText.get('faqTitle')}
      </H2>

      <div className="share-page__faq-accordion-questions">
        <SharePageFaqAccordionQuestion
          title={staticText.get('faqItem1Title')}
          answer={staticText.get('faqItem1Text')}
        />
        <SharePageFaqAccordionQuestion
          title={staticText.get('faqItem3Title')}
          answer={staticText
            .get('faqItem3Text', '')
            .replace(/\$\{ price \}/, monthlyPrice)}
        />
        <SharePageFaqAccordionQuestion
          title={staticText.get('faqItem6Title')}
          answer={staticText.get('faqItem6Text')}
        />
        <SharePageFaqAccordionQuestion
          title={staticText.get('faqItem4Title')}
          answer={staticText.get('faqItem4Text')}
        />
        <SharePageFaqAccordionQuestion
          title={staticText.get('faqItem2Title')}
          answer={staticText.get('faqItem2Text')}
        />
        <SharePageFaqAccordionQuestion
          title={staticText.get('faqItem5Title')}
          answer={staticText.get('faqItem5Text')}
        />
      </div>
    </div>
  )
}

export default SharePageFaqAccordion
